import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";

export enum AppTheme {
  LIGHT = "light",
  DARK = "dark",
}

interface IAuthContextProps {
  theme: AppTheme;
  toggleTheme: () => void;
}

// @ts-ignore
const ThemeContext = createContext<IAuthContextProps>();

export const ThemeContextProvider: React.FC<any> = ({ children }) => {
  const [theme, setTheme] = useState<AppTheme>(
    (localStorage.getItem("theme") as AppTheme) ?? AppTheme.DARK,
  );

  useEffect(() => {
    document?.querySelector("html")?.classList.remove("dark");
    localStorage.setItem("theme", AppTheme.LIGHT);
    setTheme(AppTheme.LIGHT);
  }, []);

  const changeTheme = useCallback(() => {
    if (theme === AppTheme.LIGHT) {
      setTheme(AppTheme.DARK);
      document?.querySelector("html")?.classList.add("dark");
      localStorage.setItem("theme", AppTheme.DARK);
    } else {
      setTheme(AppTheme.LIGHT);
      document?.querySelector("html")?.classList.remove("dark");
      localStorage.setItem("theme", AppTheme.LIGHT);
    }
  }, [theme]);
  return (
    <ThemeContext.Provider value={{ theme, toggleTheme: changeTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export function useAppTheme() {
  return useContext(ThemeContext);
}
